import { PrivacyPolicy } from '../legal/privacy-policy'
import { TermsAndConditions } from '../legal/terms-and-conditions'
import { ModalWrapper, ModalWrapperRefObject } from '../util/modal-wrapper'
import React, { useRef } from 'react'

export const LegalAgreementSentance = (): React.ReactElement => {
  const termsAndConditionsModalRef = useRef<ModalWrapperRefObject>(null)
  const privacyPolicyModalRef = useRef<ModalWrapperRefObject>(null)

  const handleDisplayTermsAndConditions = (e: any): void => {
    e.preventDefault()
    if (termsAndConditionsModalRef.current) termsAndConditionsModalRef.current.showModal()
  }

  const handleDisplayPrivacyPolicy = (e: any): void => {
    e.preventDefault()
    if (privacyPolicyModalRef.current) privacyPolicyModalRef.current.showModal()
  }

  return (
    <>
      I agree to{' '}
      <b>
        <a href="#" onClick={handleDisplayTermsAndConditions}>
          Terms & Conditions
        </a>
      </b>{' '}
      and{' '}
      <b>
        <a href="#" onClick={handleDisplayPrivacyPolicy}>
          Privacy Policy
        </a>
      </b>
      . (required)
      <ModalWrapper ref={termsAndConditionsModalRef} size="xl" title="Terms & Conditions">
        <TermsAndConditions />
      </ModalWrapper>
      <ModalWrapper ref={privacyPolicyModalRef} size="xl" title="Privacy Policy">
        <PrivacyPolicy />
      </ModalWrapper>
    </>
  )
}
